import React from 'react';
import type {
  ComponentType,
  ComponentProps,
} from 'react';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';
import EditableNumberField from 'views/EMR/components/EditableNumberField';

type GetUnitColumnOptions = {
  label?: string;
  size?: number;
  minSize?: number;
  Component?: ComponentType<ComponentProps<typeof EditableNumberField>>;
};

export default function getUnitColumn(minUnit: number, options?: GetUnitColumnOptions) {
  return {
    id: 'numberOfUnits',
    accessorKey: 'numberOfUnits',
    header: options?.label || 'Units',
    size: options?.size || 64,
    minSize: options?.minSize || 64,
    meta: {
      editable: {
        Component: options?.Component ?? EditableNumberField,
        props: { maskExtension: { min: minUnit, max: 999 }, className: 'border-2 border-blue-500' },
        alwaysEditable: true,
      },
    },
    cell: ({ row }) => (
      <div className="flex gap-2 flex-wrap">
        <div className="flex justify-between p-2 border border-gray-200 bg-gray-100 text-xs rounded w-12">
          {row?.original?.numberOfUnits}
        </div>
      </div>
    ),
  } as ColumnDef<VisitNoteServiceCode>;
}
